import { render, staticRenderFns } from "./trafficIndex.vue?vue&type=template&id=ef19baf2&scoped=true&"
import script from "./trafficIndex.vue?vue&type=script&lang=js&"
export * from "./trafficIndex.vue?vue&type=script&lang=js&"
import style0 from "./trafficIndex.vue?vue&type=style&index=0&id=ef19baf2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef19baf2",
  null
  
)

export default component.exports